import { useContext } from "react"
import DashContext from "../contexts/dashContext"

export function useDash() {
  const context = useContext(DashContext)
  return context
}